import { createApi } from "./api";

class BillService {
  constructor() {
    this.api = createApi("/bills");
  }

  new(formData) {
    this.api.header = { ...this.api.header, ...formData.headers };
    return this.api.post("/newBill", formData);
  }

  delete(bill_id) {
    return this.api.delete(`/deleteBill/${bill_id}`);
  }

  received(bill_id) {
    return this.api.patch(`/receivedBill/${bill_id}`);
  }

  paid(bill_id) {
    return this.api.patch(`/paidBill/${bill_id}`);
  }

  getBills() {
    return this.api.get("/getBills");
  }
}

const billService = new BillService();

export default billService;
